{"rating":"4.9","reviewCount":"140","fetchedAt":"2026-10-11T15:23:26.535Z","source":"place-details"}